import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks";
import { Redirect, Route } from "react-router-dom";
import { UNLOCK_ROUTE } from "routes";

const AdminRoute = ({ component: Component, ...rest }) => {
    const { address } = useGetAccountInfo();

    let { isAdmin } = Boolean();

    isAdmin = false;
    //Change Admin Status for theses wallet
    const ADMINS = [
        'erd1qh2m98dfkwyn4alps085a84x6pw04gar54fzna7c7frj7x9hpu3sd205vr',
        'erd1hupwkm6ls5kldvhzd02yhxy995gxtmv7px5l3t5l8jtu28jfqtlq040k9n',
        'erd1enl9te4t7tkp90f52tz4zel8687yw3t7vnranrku0jchtyytvvmqqv98xu',
        'erd1rg0x908m3w7yyucr2em8429umapnvdt06avuvdqtnf7vv6saqxqsapfjj5',
        'erd1tzq44fl4a6yl8l7zgrvv7kpgvscq9xu05uyu6fekez9pcclvxs5stp4vgw',
    ];

    if (ADMINS.includes(address)) {
        isAdmin = true;
    }

    return (
        <Route
            {...rest}
            render={(props) => (isAdmin ? <Component {...props} /> : <Redirect to={UNLOCK_ROUTE.path} />)}
        />
    )
}

export default AdminRoute;